import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import styles from "../AdminControls/AdminControls.module.css";
import PortalDrawer from "./PortalDrawer/PortalDrawer";
import { PortalDrawerData } from "../../Data/PortalDrawerData";
import { IsMesmaDev } from "../../Helpers/Permissions";

const PortalLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useAuth0();

  const isMesmaStaff = IsMesmaDev(user?.sub);

  useEffect(() => {
    if (!isLoading && !isMesmaStaff) {
      navigate("/", { replace: true });
    }
  }, [isLoading, isMesmaStaff, navigate]);

  if (isLoading) {
    return null;
  }

  if (!isMesmaStaff) {
    return <Navigate to="/" replace />;
  }

  const getSelectedItem = () => {
    const path = location.pathname;
    if (path.includes("curate-resources")) return "curate-resources";
    if (path.includes("library-lite-cutoff")) return "library-lite-cutoff";
    if (path.includes("library-rollout")) return "library-rollout";
    if (path.includes("delete-client")) return "delete-client";
    return "template-bank";
  };

  const handleItemSelect = (itemId: string) => {
    const item = PortalDrawerData.find((entry) => entry.id === itemId);
    if (item) {
      navigate(item.path);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <PortalDrawer selectedItem={getSelectedItem()} onItemSelect={handleItemSelect} />
        </div>
        <div className={styles.rightContainer}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PortalLayout;
